export default __webpack_public_path__ + "static/media/hospital_marker.89737d08.svg";